import React, { useEffect, useState } from "react";
import { Button, Input, Row, Col } from "reactstrap";
import Select from "react-select";
import { toastr } from "react-redux-toastr";
import { colourStyles4 } from "../../utils/react_select_styles";
import { Switch, Drawer, message, Upload, Button as AntdButton, Form, Input as AntdInput, Rate, Checkbox } from 'antd';
import { InboxOutlined, MinusCircleOutlined, PlusOutlined, FireFilled } from '@ant-design/icons';
import general_fetch from "../../utils/fetch";
import BackOfficeTickets from "../BackOfficeTickets";
import {impact_area_options} from "../../utils/cs_ticket_impact_area";
import { DEFAULT_PRIORITY, MAX_PRIORITY } from "../../utils/priority_options";
import {ticketChecklist} from "../../utils/ticket_checklist";

const { Dragger } = Upload;

// Constants
const MAX_DESCRIPTION_LENGTH = 5000;

// Helper function to generate unique IDs
let uniqueIdCounter = 0;
const generateUniqueId = () => {
  uniqueIdCounter += 1;
  return `${Date.now()}-${uniqueIdCounter}`;
};

const department_options = [{ value: 'none', label: 'None' }, { value: 'customer_success', label: 'Customer Success Team' }, { value: 'product', label: 'Product Team' }, { value: 'catalogue', label: 'Catalogue Team' }]

const AddCustomerTicket = ({ open, toggle, mode, active_ticket, cs_org_users, user_details, fetch_customer_tickets, all_orgs, set_page_loader, is_escalation }) => {

	const [step, set_step] = useState(0);
	const [title, set_title] = useState();
    const [impact_area, set_impact_area] = useState();
	// const [org_id, set_org_id] = useState();
	const [org_ids, set_org_ids] = useState([]);
	const [priority, set_priority] = useState(DEFAULT_PRIORITY);
	const [customer_priority, set_customer_priority] = useState();
	const [client_notification, set_client_notification] = useState(false);
	const [auto_close, set_auto_close] = useState(true);
	// const [department, set_department] = useState('none');
    const department = 'product';
	const [description, set_description] = useState();
	const [link_with_existing_ticket, set_link_with_existing_ticket] = useState(true);
	const [assignee_id, set_assignee_id] = useState();
	const [type, set_type] = useState();
	// const [use_case, set_use_case] = useState();
	// const [reproduction, set_reproduction] = useState();
	const [design_link, set_design_link] = useState();
	const [drive_links, set_drive_links] = useState(['']);
	const [drive_link_ids, set_drive_link_ids] = useState([generateUniqueId()]);
	const [drive_link_descriptions, set_drive_link_descriptions] = useState({});
	// const [comments, set_comments] = useState();
	const [files, set_files] = useState([]);
	const [file_descriptions, set_file_descriptions] = useState({});
    const [checklist, set_checklist] = useState({});
	const [has_unsaved_changes, set_has_unsaved_changes] = useState(false);
	// Create state to store form data between steps
	const [formData, set_formData] = useState({
		step0: {},
		step1: {}
	});

	const props = {
		name: 'file',
		multiple: true,
		action: '',
		customRequest: ({ fileList, onSuccess }) => { onSuccess() },
		onChange(info) {
			const { status } = info.file;
			set_files(info.fileList)

			// Initialize file descriptions for new files only, preserve existing ones
			set_file_descriptions(prev => {
				const newDescriptions = {...prev};
				info.fileList.forEach((file) => {
					if (!newDescriptions[file.uid]) {
						newDescriptions[file.uid] = '';
					}
				});
				return newDescriptions;
			});

			set_has_unsaved_changes(true);

			console.log(info.fileList)
			//   if (status !== 'uploading') {
			// 	console.log(info.file, info.fileList);
			//   }
			//   if (status === 'done') {
			// 	message.success(`${info.file.name} file uploaded successfully.`);
			//   } else if (status === 'error') {
			// 	message.error(`${info.file.name} file upload failed.`);
			//   }
		},
		onDrop(e) {
			console.log('Dropped files', e.dataTransfer.files);
		},
	};

	const onclick_handleclose = () => {
		// Check for unsaved changes
		if (has_unsaved_changes || files.length > 0 || Object.keys(file_descriptions).length > 0 ||
		    drive_links.some(link => link && link.trim() !== '') || Object.keys(drive_link_descriptions).length > 0) {
			const confirmClose = window.confirm('You have unsaved changes. Are you sure you want to close? All data will be lost.');
			if (!confirmClose) {
				return;
			}
		}

		toggle()
		set_step(0)
		set_title('')
        set_impact_area()
		// set_org_id()
        set_org_ids([])
		set_priority(DEFAULT_PRIORITY)
		set_customer_priority()
		set_client_notification(false)
		set_auto_close(true)
		// set_department('none')
		set_description('')
		set_link_with_existing_ticket(true)
		set_assignee_id()
		set_type('')
		/* set_use_case()
		set_reproduction() */
		set_design_link('')
		// set_comments()
		set_files([]) // Explicitly reset files
		set_file_descriptions({}) // Reset file descriptions
		set_drive_links(['']) // Reset drive links to initial state with one empty field
		set_drive_link_ids([generateUniqueId()]) // Reset drive link IDs
		set_drive_link_descriptions({}) // Reset drive link descriptions
		set_checklist({}) // Reset checklist
		set_has_unsaved_changes(false) // Reset unsaved changes flag
	}

	// Store form data when navigating between steps
	useEffect(() => {
		// This will run when the component mounts, and set up the form data storage
		// We don't need to do anything here, but the effect is needed for cleanup
		return () => {
			// Clean up function runs when component unmounts
			// Reset all state to prevent data persistence between different ticket creation sessions
			set_files([])
			set_file_descriptions({})
			set_drive_links([''])
			set_drive_link_ids([generateUniqueId()])
			set_drive_link_descriptions({})
			set_checklist({})
			set_has_unsaved_changes(false)
		}
	}, [])

	const check_next_button = () => {
		let go_to_next_step = 0
		if (step === 0 && title && impact_area) {
			// Save step 0 data before moving to step 1
			set_formData(prevState => ({
				...prevState,
				step0: {
					title,
					impact_area,
					org_ids,
					priority,
					customer_priority,
					client_notification,
					auto_close,
					description,
					type
				}
			}));
			go_to_next_step = 1
		} else if (step != 0) {
			go_to_next_step = 1
		}

		if (go_to_next_step) {
			set_step(step + 1)
		} else {
			toastr.error('Please enter mandatory fields')
		}

	}
	
	// Handle going back from step 1 to step 0 while preserving data
	const handleGoBack = () => {
		// Save current step data to formData
		if (step === 1) {
			// Save step 1 data (files, file_descriptions, links, drive_link_ids, drive_link_descriptions, checklist)
			set_formData(prevState => ({
				...prevState,
				step1: {
					files,
					file_descriptions,
					drive_links,
					drive_link_ids,
					drive_link_descriptions,
					checklist,
					design_link
				}
			}));
		}
		// Go back to previous step
		set_step(step - 1);
	}

	// Effect to load saved form data when changing steps
	useEffect(() => {
		// When returning to step 0, load saved step 0 data if available
		if (step === 0 && formData.step0 && Object.keys(formData.step0).length > 0) {
			// No need to restore - step0 data is preserved in state
		}
		// When moving to step 1, load saved step 1 data if available
		else if (step === 1 && formData.step1 && Object.keys(formData.step1).length > 0) {
			// Restore files, file_descriptions, drive_links, drive_link_ids, drive_link_descriptions, checklist
			if (formData.step1.files && formData.step1.files.length > 0) {
				set_files(formData.step1.files);
			}
			if (formData.step1.file_descriptions && Object.keys(formData.step1.file_descriptions).length > 0) {
				set_file_descriptions(formData.step1.file_descriptions);
			}
			if (formData.step1.drive_links && formData.step1.drive_links.length > 0) {
				set_drive_links(formData.step1.drive_links);
			}
			if (formData.step1.drive_link_ids && formData.step1.drive_link_ids.length > 0) {
				set_drive_link_ids(formData.step1.drive_link_ids);
			}
			if (formData.step1.drive_link_descriptions && Object.keys(formData.step1.drive_link_descriptions).length > 0) {
				set_drive_link_descriptions(formData.step1.drive_link_descriptions);
			}
			if (formData.step1.checklist && Object.keys(formData.step1.checklist).length > 0) {
				set_checklist(formData.step1.checklist);
			}
			if (formData.step1.design_link) {
				set_design_link(formData.step1.design_link);
			}
		}
	}, [step]);

	// Reset form data when the drawer is opened (fresh ticket creation)
	useEffect(() => {
		if (open) {
			// Reset form data when opening drawer
			set_formData({
				step0: {},
				step1: {}
			});
		}
	}, [open]);

	const submit_fn = async () => {
		try {
            if(type == 'bug' && Object.values(checklist).filter(x => x == true) == 0) {
                toastr.error('Need to check atleast 1 item in checklist')
                return
            }

			// Validate that all files have descriptions
			if (files && files.length > 0) {
				const missingDescriptions = [];
				const tooLongDescriptions = [];

				files.forEach((file) => {
					const description = (file_descriptions[file.uid] || '').trim();
					if (!description) {
						missingDescriptions.push(file.name);
					} else if (description.length > MAX_DESCRIPTION_LENGTH) {
						tooLongDescriptions.push(file.name);
					}
				});

				if (missingDescriptions.length > 0) {
					const fileList = missingDescriptions.map(name => `• ${name}`).join('; ');
					toastr.error(`File description is mandatory. Please add descriptions for: ${fileList}`, {
						timeOut: 10000
					});
					return;
				}

				if (tooLongDescriptions.length > 0) {
					const fileList = tooLongDescriptions.map(name => `• ${name}`).join('; ');
					toastr.error(`File description too long (max ${MAX_DESCRIPTION_LENGTH} characters): ${fileList}`, {
						timeOut: 10000
					});
					return;
				}
			}

			// Validate that all drive links have descriptions
			const missingLinkDescriptions = [];
			const tooLongLinkDescriptions = [];

			drive_links.forEach((link, idx) => {
				const trimmedLink = link ? link.trim() : '';
				if (trimmedLink !== '') {
					const description = (drive_link_descriptions[idx] || '').trim();
					const linkPreview = `Link ${idx + 1}: ${trimmedLink.substring(0, 50)}${trimmedLink.length > 50 ? '...' : ''}`;

					if (!description) {
						missingLinkDescriptions.push(linkPreview);
					} else if (description.length > MAX_DESCRIPTION_LENGTH) {
						tooLongLinkDescriptions.push(linkPreview);
					}
				}
			});

			if (missingLinkDescriptions.length > 0) {
				const linkList = missingLinkDescriptions.map(name => `• ${name}`).join('; ');
				toastr.error(`Link description is mandatory. Please add descriptions for: ${linkList}`, {
					timeOut: 10000
				});
				return;
			}

			if (tooLongLinkDescriptions.length > 0) {
				const linkList = tooLongLinkDescriptions.map(name => `• ${name}`).join('; ');
				toastr.error(`Link description too long (max ${MAX_DESCRIPTION_LENGTH} characters): ${linkList}`, {
					timeOut: 10000
				});
				return;
			}

			let fd = new FormData();
			fd.append('title', title)
			// if(org_id) fd.append('org_id', org_id)
            if(org_ids) {
                fd.append('org_info', JSON.stringify(org_ids.map(x => {return {id: x}})))
            }
            if(impact_area) fd.append('impact_area', impact_area)
			if(priority) fd.append('priority', priority)
			// if(customer_priority) fd.append('customer_priority', customer_priority)
			if(!client_notification) fd.append('client_notification', client_notification)
			if(!auto_close) fd.append('auto_close', auto_close)
			if(description) fd.append('description', description)
			// if(assignee_id) fd.append('assignee_id', assignee_id)
			if(type) fd.append('type', type)
            fd.append('checklist', JSON.stringify(checklist))
			// if(department) fd.append('department', department)
			// if(back_office_ticket_id_for_linking) fd.append('existing_back_office_ticket_id', back_office_ticket_id_for_linking)
			if (design_link && design_link.split('/') && design_link.split('/').length > 4) {
				if(design_link.split('/')[4].includes(' ') || design_link.split('/')[4].includes('https')){
					toastr.error('Design Link is invalid')
					return
				}
				fd.append('design_branch_id', design_link.split('/')[4])
			}
			// let additional_info = { use_case, reproduction }
			// fd.append('additional_info', JSON.stringify(additional_info))

			if(drive_links && drive_links.length){
				// Filter out empty and whitespace-only links
				const temp_drive_links = drive_links
					.map(link => link ? link.trim() : '')
					.filter(link => link !== '');

				if(temp_drive_links && temp_drive_links.length){
					fd.append('drive_links', JSON.stringify(temp_drive_links))

					// Send drive link descriptions as a JSON array (matching the order of non-empty links)
					const linkDescriptionsArray = [];
					drive_links.forEach((link, idx) => {
						const trimmedLink = link ? link.trim() : '';
						if (trimmedLink !== '') {
							const description = (drive_link_descriptions[idx] || '').trim();
							linkDescriptionsArray.push(description);
						}
					});
					fd.append('drive_link_descriptions', JSON.stringify(linkDescriptionsArray));
				}
			}

			if (files && files.length) {
				// Create an array to store file descriptions in the order of files
				const descriptionsArray = [];
				for (let file of files) {
					fd.append('files', file.originFileObj)
					// Add description for this file (validation ensures it exists)
					const description = (file_descriptions[file.uid] || '').trim();
					descriptionsArray.push(description);
				}
				// Send file descriptions as a JSON array
				fd.append('file_descriptions', JSON.stringify(descriptionsArray));
			}

			// Add is_escalation flag if in escalation mode
			if (is_escalation) {
				fd.append('is_escalation', true);
			}

			set_page_loader(true, 'Please wait...')
			let resp = await general_fetch({ url: 'customer_ticket/create', body: fd, is_form_data: true })
		
			// Show appropriate success message
			if(is_escalation) {
				toastr.success('Ticket successfully created and escalated');
			} else {
				toastr.success('Successfully created customer ticket');
			}
		
			set_page_loader(false)
			fetch_customer_tickets()
		
		// Reset form data state to prevent persistence between submissions
		set_formData({
			step0: {},
			step1: {}
		});

		// Reset unsaved changes flag
		set_has_unsaved_changes(false);

		// Close the drawer and reset all form fields
		toggle(); // Use toggle directly instead of onclick_handleclose to avoid confirmation
		set_step(0);
		// Reset all state
		set_title('')
        set_impact_area()
        set_org_ids([])
		set_priority(DEFAULT_PRIORITY)
		set_customer_priority()
		set_client_notification(false)
		set_auto_close(true)
		set_description('')
		set_link_with_existing_ticket(true)
		set_assignee_id()
		set_type('')
		set_design_link('')
		set_files([])
		set_file_descriptions({})
		set_drive_links([''])
		set_drive_link_ids([generateUniqueId()])
		set_drive_link_descriptions({})
		set_checklist({})
		} catch (e) {
			set_page_loader(false)
			console.error(e)
			toastr.error(`Couldn't ${mode === 'add' ? 'Create' : 'Update'} Ticket`)
		}
	}

	const get_assignee_list = () => {
		if(cs_org_users && cs_org_users.length){
			let temp_cs_org_users = JSON.parse(JSON.stringify(cs_org_users))
			if(department === 'customer_success'){
				temp_cs_org_users = temp_cs_org_users.filter(o => o.role.includes('cs_rep'))
			}else if(department === 'product'){
				temp_cs_org_users = temp_cs_org_users.filter(o => o.role.includes('infurnia_product_manager'))
			}else if(department === 'catalogue'){
				temp_cs_org_users = temp_cs_org_users.filter(o => o.role.includes('infurnia_catalog_admin'))
			}
			return temp_cs_org_users.map(o => { return { value: o.id, label: o.first_name } }) 
		}
		return []
	}

    const update_checklist_status = (key) => {
        set_checklist((prev) => {
            let new_checklist = JSON.parse(JSON.stringify(prev))
            new_checklist[key] = new_checklist[key] ? false : true;
            return new_checklist
        })
        console.log(key)
    }

	useEffect(() => {
		if (department === 'catalogue') {
			set_type('org')
		} else {
			set_type('')
		}
	}, [department]);

	useEffect(() => {
		console.log('filess', files)
	}, [files]);

	const Description = () => (
		<div className="mb-4">
			<div className='mb-2 bold'>Description</div>
			<textarea style={{ height: '300px', width: '100%', borderRadius: '6px', border: '1px solid #cad1d7' }} className='px-2 py-1' value={description} onChange={(e) => set_description(e.target.value)} placeholder='Type...' />
		</div>
	)

	const AssignedTo = () => (
		<div className="mb-4">
			<div className='mb-2 bold'>Assigned to</div>
			<Select
				// closeMenuOnSelect={false}
				// components={animatedComponents}
				value={{ value: assignee_id, label: cs_org_users && cs_org_users.length && assignee_id ? cs_org_users.find(o => o.id === assignee_id).first_name : '' }}
				// isMulti
				options={get_assignee_list()}
				styles={colourStyles4}
				onChange={(selectedOptions) => set_assignee_id(selectedOptions.value)}
			/>
		</div>
	)

	const UploadFiles = () => (
		<>
			<div className="mb-4">
				<Dragger {...props} fileList={files} showUploadList={false} style={{ display: 'block' }}>
					<p className="ant-upload-drag-icon">
						<InboxOutlined />
					</p>
					<p className="ant-upload-text">Click or drag file to this area to upload</p>
					<p className="ant-upload-hint">
						Supports a single or bulk upload.
					</p>
				</Dragger>
			</div>
			{files && files.length > 0 && (
				<div className="mb-4">
					<div className="mb-2 bold" style={{color: '#ff4d4f'}}>File Descriptions (Required *)</div>
					{files.map((file, idx) => {
						const hasDescription = (file_descriptions[file.uid] || '').trim() !== '';
						return (
							<div key={file.uid} className="mb-3" style={{
								padding: '12px',
								borderRadius: '4px',
								border: !hasDescription ? '2px solid #ff4d4f' : '1px solid #d9d9d9',
								backgroundColor: !hasDescription ? '#fff1f0' : 'transparent'
							}}>
								<div style={{
									fontSize: '13px',
									marginBottom: '6px',
									fontWeight: '500',
									color: !hasDescription ? '#ff4d4f' : 'rgba(0, 0, 0, 0.85)'
								}}>
									{file.name} {!hasDescription && <span style={{color: '#ff4d4f'}}>⚠️</span>}
								</div>
								<AntdInput
									type="text"
									placeholder="Description is required *"
									value={file_descriptions[file.uid] || ''}
									onChange={(e) => {
										const value = e.target.value;
										const uid = file.uid;
										// Validate length
										if (value.length > MAX_DESCRIPTION_LENGTH) {
											toastr.warning(`Description too long (max ${MAX_DESCRIPTION_LENGTH} characters)`, {
												timeOut: 3000
											});
											return;
										}
										set_file_descriptions(prev => ({
											...prev,
											[uid]: value
										}));
										set_has_unsaved_changes(true);
									}}
									style={{
										height: '36px',
										borderColor: !hasDescription ? '#ff4d4f' : undefined
									}}
									aria-required="true"
									aria-invalid={!hasDescription ? "true" : "false"}
									maxLength={MAX_DESCRIPTION_LENGTH}
								/>
								{!hasDescription && (
									<div style={{fontSize: '11px', color: '#ff4d4f', marginTop: '4px'}}>
										Description is required before submitting
									</div>
								)}
								{(file_descriptions[file.uid] || '').trim() && (
									<div style={{
										fontSize: '11px',
										color: '#888',
										marginTop: '2px',
										textAlign: 'right'
									}}>
										{(file_descriptions[file.uid] || '').length}/{MAX_DESCRIPTION_LENGTH}
									</div>
								)}
							</div>
						);
					})}
				</div>
			)}
		</>
	)

	const DriveLinks = () => (
		<div className="flex_center mb-4" style={{flexDirection:'column'}}>
		{
			drive_links && drive_links.length ? drive_links.map((link,idx) => {
				const trimmedLink = link ? link.trim() : '';
				const hasLink = trimmedLink !== '';
				const description = (drive_link_descriptions[idx] || '').trim();
				const hasDescription = description !== '';
				const showValidation = hasLink && !hasDescription;

				return (
					<div key={drive_link_ids[idx]} style={{width:'100%', marginBottom: '16px'}}>
						<div className="flex_property" style={{width:'100%'}}>
							<Input
								type='text'
								style={{ height: '36px' }}
								className='px-2 py-1 mb-2'
								placeholder='Enter link URL...'
								value={link}
								onChange={(e) => {
									const newLinks = [...drive_links];
									newLinks[idx] = e.target.value;
									set_drive_links(newLinks);
									set_has_unsaved_changes(true);
								}}
							/>
							{
								drive_links && drive_links.length>1 ?
								<MinusCircleOutlined
									className="ml-2 cp"
									onClick={() => {
										// Use functional setState for atomicity
										set_drive_links(prevLinks => prevLinks.filter((_, index) => index !== idx));
										set_drive_link_ids(prevIds => prevIds.filter((_, index) => index !== idx));
										set_drive_link_descriptions(prev => {
											const newDescriptions = { ...prev };
											delete newDescriptions[idx];
											// Reindex remaining descriptions based on sorted numeric keys
											const sortedKeys = Object.keys(newDescriptions)
												.map(k => parseInt(k, 10))
												.filter(Number.isFinite)
												.sort((a, b) => a - b);
											const reindexed = {};
											sortedKeys.forEach((oldKey, newIndex) => {
												reindexed[newIndex] = newDescriptions[oldKey];
											});
											return reindexed;
										});
										set_has_unsaved_changes(true);
									}}
								/>:""
							}
						</div>
						{hasLink && (
							<div style={{
								padding: '8px',
								borderRadius: '4px',
								border: showValidation ? '2px solid #ff4d4f' : '1px solid #d9d9d9',
								backgroundColor: showValidation ? '#fff1f0' : 'transparent'
							}}>
								<AntdInput
									type="text"
									placeholder="Link description is required *"
									value={drive_link_descriptions[idx] || ''}
									onChange={(e) => {
										const value = e.target.value;
										// Validate length
										if (value.length > MAX_DESCRIPTION_LENGTH) {
											toastr.warning(`Description too long (max ${MAX_DESCRIPTION_LENGTH} characters)`, {
												timeOut: 3000
											});
											return;
										}
										set_drive_link_descriptions(prev => ({
											...prev,
											[idx]: value
										}));
										set_has_unsaved_changes(true);
									}}
									style={{
										borderColor: showValidation ? '#ff4d4f' : undefined
									}}
									maxLength={MAX_DESCRIPTION_LENGTH}
								/>
								{showValidation && (
									<div style={{
										fontSize: '12px',
										color: '#ff4d4f',
										marginTop: '4px',
										fontWeight: 'bold'
									}}>
										⚠️ Description required
									</div>
								)}
								{description && (
									<div style={{
										fontSize: '11px',
										color: '#888',
										marginTop: '2px',
										textAlign: 'right'
									}}>
										{description.length}/{MAX_DESCRIPTION_LENGTH}
									</div>
								)}
							</div>
						)}
					</div>
				);
			}):''
		}
		<AntdButton type="dashed" className="flex_center" onClick={() => {
			set_drive_links([...drive_links, '']);
			set_drive_link_ids([...drive_link_ids, generateUniqueId()]);
		}}><PlusOutlined /> Add Link</AntdButton>
		</div>
	)

	const Checklist = () => (
		<div className="flex_center mb-4" style={{flexDirection:'column'}}>
		{
			Object.keys(ticketChecklist).map((key, idx) => (
				<div className="flex_property" style={{width:'100%'}}>
                    <Checkbox checked={checklist[key]} onClick={() => {update_checklist_status(key)}}>
                        <div>{ticketChecklist[key]}</div>
                    </Checkbox>
				</div>
			))
		}
		</div>
	)

	return (
		<Drawer open={open} onClose={toggle} size="large" title='Create Ticket' >
			{/* <CspModalHeader title={(mode==='add' ? 'Create' : 'Update') + ' Customer Ticket'} toggle={onclick_handleclose}/> */}
			{/* <CspModalBody style={{maxHeight:'600px'}}> */}
			{
				step === 0 ?
					<>
                        <Row>
                            <Col md={8}>
                                <div className='mb-2 bold'>Title*</div>
                                <Input type='text' style={{ height: '36px', color: '#525f7f' }} className='px-2 py-1 mb-4' placeholder={'Type...'} value={title} onChange={(e) => set_title(e.target.value)} />
                            </Col>
                                <Col md={4}>
                                    <div className='mb-2 bold'>Impact Area*</div>
                                    <div style={{ zIndex: 999999999, position: 'relative' }}>
                                        <Select
                                            value={{ value: impact_area, label: impact_area }}
                                            options={impact_area_options}
                                            onChange={(selectedOptions) => set_impact_area(selectedOptions.value)}
                                        />
                                    </div>
                                </Col>
                        </Row>
						<div className='mb-2 bold'>Org</div>
						<div className="mb-4">
							{
									<Select
										// closeMenuOnSelect={false}
										// components={animatedComponents}
										value={org_ids.map(org_id => {return { value: org_id, label: all_orgs && all_orgs.length && all_orgs.find(o => o.id === org_id) ? all_orgs.find(o => o.id === org_id).name : '' }})}
										isMulti
										options={all_orgs && all_orgs.length ? all_orgs.map(x => { return { value: x.id, label: x.name } }) : []}
										onChange={(selectedOptions) => set_org_ids(selectedOptions.map(x => x.value))}
									/>
							}
						</div>

                        <label className="form-control-label mt-2 mb-4 flex_property" htmlFor="input-address" style={{ minWidth: '60%', marginBottom: 0 }}>
                            <div className='mr-2'>Type</div>
                            <div style={{ minHeight: '32px', fontWeight: 400 }} className="ml-2 mr-2 flex_property" onClick={() => { set_type('feature') }} >
                                <input type="radio" className="mr-2" checked={type === 'feature' ? true : false} />
                                <div className="mr-4">Feature</div>
                            </div>
                            <div style={{ minHeight: '32px', fontWeight: 400 }} className="ml-2 mr-2 flex_property" onClick={() => { set_type('bug') }} >
                                <input type="radio" className="mr-2" checked={type === 'bug' ? true : false} />
                                <div>Bug</div>
                            </div>
                        </label>
                        {Description()}

                        {
                            <div className="mb-5">
                                <div className='mb-2 bold'>Priority ({MAX_PRIORITY} fire is highest priority)</div>
                                <Rate 
                                    className='priority_rating' 
                                    onChange={(value) => set_priority(value ? value : 0)} 
                                    value={priority ? priority : 0} 
                                    character={({index = 0}) => <FireFilled/>}
                                    count={MAX_PRIORITY}
                                />
                            </div>
                        }
                        {
                            // <>
                            //     <div className='mb-4 bold'>Priority (to be assigned by CS). 1 is highest priority, 5 is lowest</div>
                            //     <div className="flex_property mb-4" style={{ fontWeight: 400 }}>
                            //         <div>
                            //             <div style={{ minHeight: '32px' }}></div>
                            //             {/* <div style={{ minHeight: '32px', fontSize: '12px' }}>Highest Priority</div> */}
                            //         </div>
                            //         {[1, 2, 3, 4, 5].map(x => (
                            //             <div>
                            //                 <div style={{ minHeight: '32px' }} className="ml-2 mr-2">{x}</div>
                            //                 <div style={{ minHeight: '32px' }} className="ml-2 mr-2" onClick={() => set_priority(x)} >
                            //                     <input type="radio" checked={priority === x ? true : false} />
                            //                 </div>
                            //             </div>
                            //         ))}
                            //         <div>
                            //             <div style={{ minHeight: '32px' }}></div>
                            //             {/* <div style={{ minHeight: '32px', fontSize: '12px' }}>Lowset Priority</div> */}
                            //         </div>
                            //     </div>
                            // </>
                        }
                        {
                            // <>
                            //     <div className='mb-4 bold'>Customer priority or Client misery level (1 is highest priority, 5 is lowest)</div>
                            //     <div className="flex_property mb-4" style={{ fontWeight: 400 }}>
                            //         <div>
                            //             <div style={{ minHeight: '32px' }}></div>
                            //             {/* <div style={{ minHeight: '32px', fontSize: '12px' }}>High priority for customer</div> */}
                            //         </div>
                            //         {[1, 2, 3, 4, 5].map(x => (
                            //             <div>
                            //                 <div style={{ minHeight: '32px' }} className="ml-2 mr-2">{x}</div>
                            //                 <div style={{ minHeight: '32px' }} className="ml-2 mr-2" onClick={() => set_customer_priority(x)} >
                            //                     <input type="radio" checked={customer_priority === x ? true : false} />
                            //                 </div>
                            //             </div>
                            //         ))}
                            //         <div>
                            //             <div style={{ minHeight: '32px' }}></div>
                            //             {/* <div style={{ minHeight: '32px', fontSize: '12px' }}>Low priority for customer</div> */}
                            //         </div>
                            //     </div>
                            // </>
                        }
                        {
                            /* <div className='mb-2 bold'>Dependency</div>
                        <div className="mb-4">
                            <Select
                                // closeMenuOnSelect={false}
                                // components={animatedComponents}
                                value={department ? { value: department, label: department_options.find(o => o.value === department).label } : {}}
                                // isMulti
                                options={department_options}
                                // onChange={(selectedOptions) => set_department(selectedOptions.value)}
                            />
                            </div> */
                        }
						{
							/* department != 'none'?
							<div className="flex_property mb-4">
								<Switch size="small" className="mr-2" value={auto_close} onClick={() => set_auto_close(!auto_close)}/>
								<div>Automatically <span className="bold">mark as done</span> once the dependency Product ticket is marked as done.</div>
							</div>:"" */
						}
					</> : (
						// step === 1 ?
							<>
								{
									// department === 'none' ?
										<>
											<div className='mb-2 bold'>Upload files</div>
											{UploadFiles()}
											<div className='mb-2 bold'>Drive/Sheets/Docs Links</div>
											{DriveLinks()}
											<div className='mb-2 bold'>Checklist</div>
											{type == 'bug' ? Checklist() : ''}
										</> 
                                        /* :
										<>
											<div className="mb-2 bold">Select one option</div>
											<div style={{ minHeight: '32px', fontWeight: 400 }} className="ml-2 mr-2 flex_property" onClick={() => { set_link_with_existing_ticket(true) }} >
												<input type="radio" className="mr-2" checked={link_with_existing_ticket ? true : false} />
												<div>Link this ticket with an existing Back-office ticket</div>
											</div>
											<div style={{ minHeight: '32px', fontWeight: 400 }} className="ml-2 mr-2 mb-4 flex_property" onClick={() => { set_link_with_existing_ticket(false) }} >
												<input type="radio" className="mr-2" checked={!link_with_existing_ticket ? true : false} />
												<div>Create new Back-office ticket</div>
											</div>
										</> */
								}
							</> 
                            /* : (
								step === 2 && !link_with_existing_ticket ?
									<>
										{
											department === 'customer_success' ?
												<>
													{AssignedTo()}
													{Description()}
													<div className='mb-2 bold'>Upload files</div>
													{UploadFiles()}
													<div className='mb-2 bold'>Drive/Sheets/Docs Links</div>
													{DriveLinks()}
												</> : (
													department === 'product' ?
														<>
															<label className="form-control-label mt-2 mb-4 flex_property" htmlFor="input-address" style={{ minWidth: '60%', marginBottom: 0 }}>
																<div className='mr-2'>Type</div>
																<div style={{ minHeight: '32px', fontWeight: 400 }} className="ml-2 mr-2 flex_property" onClick={() => { set_type('feature') }} >
																	<input type="radio" className="mr-2" checked={type === 'feature' ? true : false} />
																	<div className="mr-4">Feature</div>
																</div>
																<div style={{ minHeight: '32px', fontWeight: 400 }} className="ml-2 mr-2 flex_property" onClick={() => { set_type('bug') }} >
																	<input type="radio" className="mr-2" checked={type === 'bug' ? true : false} />
																	<div>Bug</div>
																</div>
															</label>
															{
																type === 'feature' || type === 'bug' ? AssignedTo() : ""
															}
															{
																type === 'feature' ?
																	<>
																		<div className='mb-2 bold'>Use Case</div>
																		<textarea style={{ height: '100px', width: '100%', borderRadius: '6px', border: '1px solid #cad1d7' }} className='px-2 py-1 mb-4' value={use_case} onChange={(e) => set_use_case(e.target.value)} placeholder='e.g. The client is trying to create shutters with a design that is shown in this image link <url>' />
																		{Description()}
																		<div className='mb-2'>Upload files</div>
																		{UploadFiles()}
																		<div className='mb-2 bold'>Drive/Sheets/Docs Links</div>
																		{DriveLinks()}
																	</> : (
																		type === 'bug' ?
																			<>
																				<div className='mb-2 bold'>Reproduction</div>
																				<textarea style={{ height: '100px', width: '100%', borderRadius: '6px', border: '1px solid #cad1d7' }} className='px-2 py-1 mb-4' value={reproduction} onChange={(e) => set_reproduction(e.target.value)} placeholder='e.g. Add a Cabinet, Change the shutter and external finish and then change shutter design from normal to profile' />
																				<div className='mb-2'>Design Link</div>
																				<div className="flex_property mb-4" style={{ width: '100%' }}>
																					<Input type='text' style={{ height: '36px', width: '60%' }} className='px-2 py-1 mr-2' placeholder={'Type...'} value={design_link} onChange={(e) => set_design_link(e.target.value)} />
																					{
                                                                                        // {org_id ? <Button color='secondary'>Add "pm1" to the Org</Button> : ''}
                                                                                    }
																				</div>
																				<div className='mb-2 bold'>Upload files</div>
																				{UploadFiles()}
																				<div className='mb-2 bold'>Drive/Sheets/Docs Links</div>
																				{DriveLinks()}
																				{
                                                                                    // <div className='mb-2 bold'>Comments</div>
                                                                                    // <textarea style={{ height: '100px', width: '100%', borderRadius: '6px', border: '1px solid #cad1d7' }} className='px-2 py-1 mb-4' value={comments} onChange={(e) => set_comments(e.target.value)} placeholder='e.g. the same shutter related bug was also noticed at partition level also' />
                                                                                }
																			</> : ""
																	)
															}
														</> :
														<>
															{AssignedTo()}
															<label className="form-control-label mt-2 " htmlFor="input-address" style={{ minWidth: '60%', marginBottom: 0 }}>
																<div className='mr-2 bold'>Global/Org</div>
																<div className="flex_property mb-4">
																	<div style={{ minHeight: '32px', fontWeight: 400 }} className="ml-2 mr-2 flex_property" onClick={() => { set_type('org') }} >
																		<input type="radio" className="mr-2" checked={type === 'org' ? true : false} />
																		<div className="mr-4">Org</div>
																	</div>
																	<div style={{ minHeight: '32px', fontWeight: 400 }} className="ml-2 mr-2 flex_property" onClick={() => { set_type('global') }} >
																		<input type="radio" className="mr-2" checked={type === 'global' ? true : false} />
																		<div className="mr-4">Global</div>
																	</div>
																	<div style={{ minHeight: '32px', fontWeight: 400 }} className="ml-2 mr-2 flex_property" onClick={() => { set_type('org_and_global') }} >
																		<input type="radio" className="mr-2" checked={type === 'org_and_global' ? true : false} />
																		<div>Both</div>
																	</div>
																</div>
															</label>
															{Description()}
															<div className='mb-2 bold'>Upload files</div>
															{UploadFiles()}
															<div className='mb-2 bold'>Drive/Sheets/Docs Links</div>
															{DriveLinks()}
														</>
												)
										}
									</> :
									<>
                                        {
                                            // <BackOfficeTickets cs_org_users={cs_org_users} all_stores={all_orgs} link_mode={true} link_mode_department={department} back_office_ticket_id_for_linking={back_office_ticket_id_for_linking} set_back_office_ticket_id_for_linking={set_back_office_ticket_id_for_linking} user_details={user_details}/>
                                            // <div style={{position:"absolute", bottom:'8px', width:'95%', height:'40px', backgroundColor:"white"}} className="flex_between p-2">
                                            // <Button color='primary' onClick={() => set_step(step - 1)}>Go Back</Button>
                                            // <Button color='primary' disabled={!back_office_ticket_id_for_linking} onClick={submit_fn}>Link Product Ticket & Submit</Button>
                                            // </div>:""
                                        }
									</>
							) */
					)
			}
			{/* </CspModalBody> */}
			{/* <CspModalFooter> */}
			{
                // step > 0 && !(step==2 && link_with_existing_ticket) ? <Button color='primary' onClick={() => set_step(step - 1)}>Back</Button> : ''
                step === 1 ? <Button color='primary' onClick={handleGoBack}>Back</Button> : ''
            }
			{
                // step < 2 && !(step === 1 && department === 'none') ? <Button color='primary' onClick={check_next_button}>Next</Button> : ''
                step === 0 ? <Button color='primary' onClick={check_next_button}>Next</Button> : ''
            }
			{
                // (step === 2 && !link_with_existing_ticket) || (step === 1 && department === 'none') ? <Button color='primary' onClick={submit_fn}>Submit</Button> : ''
                step === 1 ? <Button color='primary' onClick={submit_fn}>Submit</Button> : ''
            }
			{/* </CspModalFooter> */}
		</Drawer>
	)
}

export default AddCustomerTicket;
